import type { Command } from 'commander';
import { registerEnterpriseJobsList } from './list';
import { registerEnterpriseJobsView } from './view';
import { registerEnterpriseJobsCreate } from './create';
import { registerEnterpriseJobsUpdate } from './update';
import {
	registerEnterpriseJobsPublish,
	registerEnterpriseJobsUnpublish,
	registerEnterpriseJobsDelete,
	registerEnterpriseJobsCopy,
	registerEnterpriseJobsClose,
} from './lifecycle';
import { registerEnterpriseJobsBatch } from './batch';

export function registerEnterpriseJobsCommand(parent: Command): void {
	const jobs = parent.command('jobs').description('Manage your company job postings');
	registerEnterpriseJobsList(jobs);
	registerEnterpriseJobsView(jobs);
	registerEnterpriseJobsCreate(jobs);
	registerEnterpriseJobsUpdate(jobs);
	registerEnterpriseJobsPublish(jobs);
	registerEnterpriseJobsUnpublish(jobs);
	registerEnterpriseJobsDelete(jobs);
	registerEnterpriseJobsCopy(jobs);
	registerEnterpriseJobsClose(jobs);
	registerEnterpriseJobsBatch(jobs);
}
